var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.registration
    ? _c("div", [
        _vm.isLoading
          ? _c(
              "div",
              { staticClass: "text-center" },
              [_c("loader", { attrs: { show: true } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            { staticClass: "form-row" },
            [
              _c("display-validation-collector", {
                staticClass: "col-11",
                model: {
                  value: _vm.validationCollector,
                  callback: function($$v) {
                    _vm.validationCollector = $$v
                  },
                  expression: "validationCollector"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "col col-12 col-sm-6 col-md-6 col-lg-3 order-1 order-sm-1"
              },
              [
                _c("div", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group condensed row" }, [
                    _c(
                      "label",
                      { staticClass: "col-5 col-form-label col-form-label-sm" },
                      [_vm._v("Serial Number")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.registration.machineRegistrationData
                              .serialNumber,
                          expression:
                            "registration.machineRegistrationData.serialNumber"
                        }
                      ],
                      staticClass: "col-6 form-control form-control-sm",
                      attrs: {
                        type: "text",
                        disabled: _vm.isLoadingMachineInformation
                      },
                      domProps: {
                        value:
                          _vm.registration.machineRegistrationData.serialNumber
                      },
                      on: {
                        change: _vm.loadMachineInformation,
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.loadMachineInformation($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registration.machineRegistrationData,
                            "serialNumber",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "col-1 col-form-label col-form-label-sm text-danger pl-1"
                      },
                      [_vm._v("*")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group condensed row" }, [
                    _c(
                      "label",
                      { staticClass: "col-5 col-form-label col-form-label-sm" },
                      [_vm._v("Machine / Model")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.registration.machineRegistrationData
                              .machineModel,
                          expression:
                            "registration.machineRegistrationData.machineModel"
                        }
                      ],
                      staticClass: "col-6 form-control form-control-sm",
                      attrs: {
                        type: "text",
                        disabled: _vm.isMachineModelDisabled
                      },
                      domProps: {
                        value:
                          _vm.registration.machineRegistrationData.machineModel
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registration.machineRegistrationData,
                            "machineModel",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.isLoadingMachineInformation
                      ? _c(
                          "div",
                          { staticClass: "col-1" },
                          [
                            _c("loader", {
                              attrs: {
                                show: _vm.isLoadingMachineInformation,
                                small: true
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "label",
                          {
                            staticClass:
                              " col-form-label col-form-label-sm text-danger pl-1"
                          },
                          [_vm._v("*")]
                        )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group condensed row" }, [
                    _c(
                      "label",
                      { staticClass: "col-5 col-form-label col-form-label-sm" },
                      [_vm._v("Supplier / provider")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.registration.machineRegistrationData.storeName,
                          expression:
                            "registration.machineRegistrationData.storeName"
                        }
                      ],
                      staticClass: "col-6 form-control form-control-sm",
                      attrs: { type: "text" },
                      domProps: {
                        value:
                          _vm.registration.machineRegistrationData.storeName
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registration.machineRegistrationData,
                            "storeName",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "col-1 col-form-label col-form-label-sm text-danger pl-1"
                      },
                      [_vm._v("*")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col col-12 col-sm-6 col-md-6 col-lg-3 order-1 order-sm-1"
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-group condensed row" }, [
                  _c(
                    "label",
                    { staticClass: "col-5 col-form-label col-form-label-sm" },
                    [_vm._v("Name / End User")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.registration.registrationData.customerName,
                        expression: "registration.registrationData.customerName"
                      }
                    ],
                    staticClass: "col-6 form-control form-control-sm",
                    attrs: { type: "text", disabled: _vm.hasPartialSubmits },
                    domProps: {
                      value: _vm.registration.registrationData.customerName
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.registration.registrationData,
                          "customerName",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "col-1 col-form-label col-form-label-sm text-danger pl-1"
                    },
                    [_vm._v("*")]
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "form-group condensed row" }, [
                    _c(
                      "label",
                      { staticClass: "col-5 col-form-label col-form-label-sm" },
                      [_vm._v("Street")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.registration.registrationData.customerStreet,
                          expression:
                            "registration.registrationData.customerStreet"
                        }
                      ],
                      staticClass: "col-6 form-control form-control-sm",
                      attrs: { type: "text", disabled: _vm.hasPartialSubmits },
                      domProps: {
                        value: _vm.registration.registrationData.customerStreet
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registration.registrationData,
                            "customerStreet",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "col-1 col-form-label col-form-label-sm text-danger pl-1"
                      },
                      [_vm._v("*")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group condensed row" }, [
                    _c(
                      "label",
                      { staticClass: "col-5 col-form-label col-form-label-sm" },
                      [_vm._v("City")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.registration.registrationData.customerCity,
                          expression:
                            "registration.registrationData.customerCity"
                        }
                      ],
                      staticClass: "col-6 form-control form-control-sm",
                      attrs: { type: "text", disabled: _vm.hasPartialSubmits },
                      domProps: {
                        value: _vm.registration.registrationData.customerCity
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registration.registrationData,
                            "customerCity",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "col-1 col-form-label col-form-label-sm text-danger pl-1"
                      },
                      [_vm._v("*")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group condensed row" }, [
                    _c(
                      "label",
                      { staticClass: "col-5 col-form-label col-form-label-sm" },
                      [_vm._v("State")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.registration.registrationData.customerState,
                          expression:
                            "registration.registrationData.customerState"
                        }
                      ],
                      staticClass: "col-6 form-control form-control-sm",
                      attrs: { type: "text", disabled: _vm.hasPartialSubmits },
                      domProps: {
                        value: _vm.registration.registrationData.customerState
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registration.registrationData,
                            "customerState",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group condensed row" }, [
                    _c(
                      "label",
                      { staticClass: "col-5 col-form-label col-form-label-sm" },
                      [_vm._v("ZipCode")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.registration.registrationData.customerZipCode,
                          expression:
                            "registration.registrationData.customerZipCode"
                        }
                      ],
                      staticClass: "col-6 form-control form-control-sm",
                      attrs: { type: "text", disabled: _vm.hasPartialSubmits },
                      domProps: {
                        value: _vm.registration.registrationData.customerZipCode
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registration.registrationData,
                            "customerZipCode",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "col-1 col-form-label col-form-label-sm text-danger pl-1"
                      },
                      [_vm._v("*")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group condensed row" }, [
                    _c(
                      "label",
                      { staticClass: "col-5 col-form-label col-form-label-sm" },
                      [_vm._v("Country")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.registration.registrationData.customerCountry,
                          expression:
                            "registration.registrationData.customerCountry"
                        }
                      ],
                      staticClass: "col-6 form-control form-control-sm",
                      attrs: { type: "text", disabled: _vm.hasPartialSubmits },
                      domProps: {
                        value: _vm.registration.registrationData.customerCountry
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registration.registrationData,
                            "customerCountry",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "col-1 col-form-label col-form-label-sm text-danger pl-1"
                      },
                      [_vm._v("*")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col col-12 col-sm-6 col-md-6 col-lg-3 order-1 order-sm-1"
              },
              [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "form-group condensed row" }, [
                  _c(
                    "label",
                    { staticClass: "col-5 col-form-label col-form-label-sm" },
                    [_vm._v("Address")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-control custom-checkbox" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.registration.registrationData.isSameAddress,
                            expression:
                              "registration.registrationData.isSameAddress"
                          }
                        ],
                        staticClass: "custom-control-input",
                        attrs: {
                          type: "checkbox",
                          disabled: _vm.hasPartialSubmits
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.registration.registrationData.isSameAddress
                          )
                            ? _vm._i(
                                _vm.registration.registrationData.isSameAddress,
                                null
                              ) > -1
                            : _vm.registration.registrationData.isSameAddress
                        },
                        on: {
                          change: function($event) {
                            var $$a =
                                _vm.registration.registrationData.isSameAddress,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.registration.registrationData,
                                    "isSameAddress",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.registration.registrationData,
                                    "isSameAddress",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.registration.registrationData,
                                "isSameAddress",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "custom-control-label label-override" },
                        [_vm._v("Same as customer address")]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                !_vm.registration.registrationData.isSameAddress
                  ? _c("div", [
                      _c("div", { staticClass: "form-group condensed row" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "col-5 col-form-label col-form-label-sm"
                          },
                          [_vm._v("Street")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.registration.registrationData
                                  .installedStreet,
                              expression:
                                "registration.registrationData.installedStreet"
                            }
                          ],
                          staticClass: "col-6 form-control form-control-sm",
                          attrs: {
                            type: "text",
                            disabled: _vm.hasPartialSubmits
                          },
                          domProps: {
                            value:
                              _vm.registration.registrationData.installedStreet
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.registration.registrationData,
                                "installedStreet",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "col-1 col-form-label col-form-label-sm text-danger pl-1"
                          },
                          [_vm._v("*")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group condensed row" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "col-5 col-form-label col-form-label-sm"
                          },
                          [_vm._v("City")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.registration.registrationData.installedCity,
                              expression:
                                "registration.registrationData.installedCity"
                            }
                          ],
                          staticClass: "col-6 form-control form-control-sm",
                          attrs: {
                            type: "text",
                            disabled: _vm.hasPartialSubmits
                          },
                          domProps: {
                            value:
                              _vm.registration.registrationData.installedCity
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.registration.registrationData,
                                "installedCity",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "col-1 col-form-label col-form-label-sm text-danger pl-1"
                          },
                          [_vm._v("*")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group condensed row" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "col-5 col-form-label col-form-label-sm"
                          },
                          [_vm._v("State")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.registration.registrationData
                                  .installedState,
                              expression:
                                "registration.registrationData.installedState"
                            }
                          ],
                          staticClass: "col-6 form-control form-control-sm",
                          attrs: {
                            type: "text",
                            disabled: _vm.hasPartialSubmits
                          },
                          domProps: {
                            value:
                              _vm.registration.registrationData.installedState
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.registration.registrationData,
                                "installedState",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group condensed row" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "col-5 col-form-label col-form-label-sm"
                          },
                          [_vm._v("ZipCode")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.registration.registrationData
                                  .installedZipCode,
                              expression:
                                "registration.registrationData.installedZipCode"
                            }
                          ],
                          staticClass: "col-6 form-control form-control-sm",
                          attrs: {
                            type: "text",
                            disabled: _vm.hasPartialSubmits
                          },
                          domProps: {
                            value:
                              _vm.registration.registrationData.installedZipCode
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.registration.registrationData,
                                "installedZipCode",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "col-1 col-form-label col-form-label-sm text-danger pl-1"
                          },
                          [_vm._v("*")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group condensed row" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "col-5 col-form-label col-form-label-sm"
                          },
                          [_vm._v("Country")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.registration.registrationData
                                  .installedCountry,
                              expression:
                                "registration.registrationData.installedCountry"
                            }
                          ],
                          staticClass: "col-6 form-control form-control-sm",
                          attrs: {
                            type: "text",
                            disabled: _vm.hasPartialSubmits
                          },
                          domProps: {
                            value:
                              _vm.registration.registrationData.installedCountry
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.registration.registrationData,
                                "installedCountry",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "col-1 col-form-label col-form-label-sm text-danger pl-1"
                          },
                          [_vm._v("*")]
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col col-12 col-sm-6 col-md-6 col-lg-3 order-1 order-sm-1"
              },
              [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-group condensed row" }, [
                  _c(
                    "label",
                    { staticClass: "col-5 col-form-label col-form-label-sm" },
                    [_vm._v("Email")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.registration.registrationData.email,
                        expression: "registration.registrationData.email",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "col-6 form-control form-control-sm",
                    attrs: { type: "text", disabled: _vm.hasPartialSubmits },
                    domProps: {
                      value: _vm.registration.registrationData.email
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.registration.registrationData,
                          "email",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "col-1 col-form-label col-form-label-sm text-danger pl-1"
                    },
                    [_vm._v("*")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group condensed row" }, [
                  _c(
                    "label",
                    { staticClass: "col-5 col-form-label col-form-label-sm" },
                    [_vm._v("Phone number")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.registration.registrationData.phoneNumber,
                        expression: "registration.registrationData.phoneNumber"
                      }
                    ],
                    staticClass: "col-6 form-control form-control-sm",
                    attrs: { type: "text", disabled: _vm.hasPartialSubmits },
                    domProps: {
                      value: _vm.registration.registrationData.phoneNumber
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.registration.registrationData,
                          "phoneNumber",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "col-1 col-form-label col-form-label-sm text-danger pl-1"
                    },
                    [_vm._v("*")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group condensed row" },
                  [
                    _c(
                      "label",
                      { staticClass: "col-5 col-form-label col-form-label-sm" },
                      [_vm._v("Purchase Date")]
                    ),
                    _vm._v(" "),
                    _c("date-picker", {
                      staticClass: "col-6 px-0",
                      model: {
                        value:
                          _vm.registration.machineRegistrationData.purchaseDate,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.registration.machineRegistrationData,
                            "purchaseDate",
                            $$v
                          )
                        },
                        expression:
                          "registration.machineRegistrationData.purchaseDate"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "col-1 col-form-label col-form-label-sm text-danger pl-1"
                      },
                      [_vm._v("*")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group condensed row" },
                  [
                    _c(
                      "label",
                      { staticClass: "col-5 col-form-label col-form-label-sm" },
                      [_vm._v("Purchase Ticket")]
                    ),
                    _vm._v(" "),
                    _c("attachment-selector", {
                      staticClass: "col-6",
                      attrs: {
                        "allowed-mime-types": _vm.allowedMimeTypes,
                        "max-total-file-size-in-bytes":
                          _vm.maxTotalFileSizeInBytes,
                        disabled: false
                      }
                    }),
                    _vm._v(" "),
                    _vm.isAirTube
                      ? _c(
                          "label",
                          {
                            staticClass:
                              "col-1 col-form-label col-form-label-sm text-danger pl-1"
                          },
                          [_vm._v("*")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isAirTube
                  ? _c("div", { staticClass: "form-group condensed row" }, [
                      _c(
                        "label",
                        {
                          staticClass: "col-5 col-form-label col-form-label-sm"
                        },
                        [_vm._v("Installed Smart-link")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-sm-6 px-sm-0" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.isInstalledSmartLink,
                                expression: "isInstalledSmartLink"
                              }
                            ],
                            staticClass: "custom-select custom-select-sm",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.isInstalledSmartLink = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "true" } }, [
                              _vm._v("Yes")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "false" } }, [
                              _vm._v("No")
                            ])
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAirTube && _vm.isStringTrue(_vm.isInstalledSmartLink)
                  ? _c("div", { staticClass: "form-group condensed row" }, [
                      _c(
                        "label",
                        {
                          staticClass: "col-5 col-form-label col-form-label-sm"
                        },
                        [_vm._v("Activated Smart-link")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-sm-6 px-sm-0" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.isActivatedSmartLink,
                                expression: "isActivatedSmartLink"
                              }
                            ],
                            staticClass: "custom-select custom-select-sm",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.isActivatedSmartLink = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "true" } }, [
                              _vm._v("Yes")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "false" } }, [
                              _vm._v("No")
                            ])
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAirTube && _vm.isStringTrue(_vm.isActivatedSmartLink)
                  ? _c("div", { staticClass: "form-group condensed row" }, [
                      _c(
                        "label",
                        {
                          staticClass: "col-5 col-form-label col-form-label-sm"
                        },
                        [_vm._v("Serial # Smart-link")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.registration.machineRegistrationData
                                .serialNumberSmartLink,
                            expression:
                              "registration.machineRegistrationData.serialNumberSmartLink"
                          }
                        ],
                        staticClass: "col-6 form-control form-control-sm",
                        attrs: { type: "text" },
                        domProps: {
                          value:
                            _vm.registration.machineRegistrationData
                              .serialNumberSmartLink
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.registration.machineRegistrationData,
                              "serialNumberSmartLink",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAirTube && _vm.isStringTrue(_vm.isActivatedSmartLink)
                  ? _c("div", { staticClass: "form-group condensed row" }, [
                      _c(
                        "label",
                        {
                          staticClass: "col-5 col-form-label col-form-label-sm"
                        },
                        [_vm._v("IMEI # Smart-link")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.registration.machineRegistrationData
                                .imeiSmartLink,
                            expression:
                              "registration.machineRegistrationData.imeiSmartLink"
                          }
                        ],
                        staticClass: "col-6 form-control form-control-sm",
                        attrs: { type: "text" },
                        domProps: {
                          value:
                            _vm.registration.machineRegistrationData
                              .imeiSmartLink
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.registration.machineRegistrationData,
                              "imeiSmartLink",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAirTube && _vm.isStringTrue(_vm.isActivatedSmartLink)
                  ? _c(
                      "div",
                      { staticClass: "form-group condensed row" },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "col-5 col-form-label col-form-label-sm"
                          },
                          [_vm._v("Start Up Date")]
                        ),
                        _vm._v(" "),
                        _c("date-picker", {
                          staticClass: "col-6 px-0",
                          model: {
                            value:
                              _vm.registration.machineRegistrationData
                                .startUpDate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.registration.machineRegistrationData,
                                "startUpDate",
                                $$v
                              )
                            },
                            expression:
                              "registration.machineRegistrationData.startUpDate"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-md-center" }, [
          _c("div", { staticClass: "col-lg-4" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-sm-6 p-1" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary btn-block",
                    attrs: {
                      disabled: _vm.isLoading || _vm.isCreating || _vm.isAdding
                    },
                    on: { click: _vm.partialSubmit }
                  },
                  [
                    _vm._v(
                      "\n                        Add registrations\n                        "
                    ),
                    _c("loader", { attrs: { show: _vm.isAdding, small: true } })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-sm-6 p-1" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-block",
                    attrs: {
                      disabled:
                        !_vm.hasRegistrations ||
                        _vm.isLoading ||
                        _vm.isCreating ||
                        _vm.isAdding
                    },
                    on: { click: _vm.submit }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.submitButtonText) +
                        "\n                        "
                    ),
                    _c("loader", {
                      attrs: { show: _vm.isCreating, small: true }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("small", { staticClass: "form-text text-muted" }, [
              _vm._v(
                "Standard warranty is 1 year from startup or 18 months from production whichever occurs first."
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("notifications", {
              attrs: {
                classes: "vue-notification-override",
                position: "bottom right"
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "text-center mt-4 mb-4" }, [
      _c(
        "span",
        {
          staticClass: "badge badge-pill badge-primary d-none d-sm-inline-block"
        },
        [_vm._v("1")]
      ),
      _vm._v(" Machine Registration\n                    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "text-center mt-4 mb-4" }, [
      _c(
        "span",
        {
          staticClass: "badge badge-pill badge-primary d-none d-sm-inline-block"
        },
        [_vm._v("2")]
      ),
      _vm._v(" Customer Details\n                ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "text-center mt-4 mb-4" }, [
      _c(
        "span",
        {
          staticClass: "badge badge-pill badge-primary d-none d-sm-inline-block"
        },
        [_vm._v("3")]
      ),
      _vm._v(" Installed Details\n                ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "text-center mt-4 mb-4" }, [
      _c(
        "span",
        {
          staticClass: "badge badge-pill badge-primary d-none d-sm-inline-block"
        },
        [_vm._v("4")]
      ),
      _vm._v(" Additional Information\n                ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-row d-flex justify-content-center my-2 mb-4" },
      [
        _c("div", {
          staticClass: "g-recaptcha",
          attrs: {
            "data-type": "image",
            "data-sitekey": "6Lfj4FMbAAAAABKTKUtkzIgNPDx23JJkovilCIY6"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }